import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import kioskEditStore from '../../store/kioskEditStore';
import { LOCALES } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import TabPicker from '~/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text from '~/view/components/Text/Text';

const KioskLanguage: FC = observer((): JSX.Element => {
  const handleLanguageChange = (value: LOCALES) => {
    kioskEditStore.changeEditableKiosk({ language: value });
  };

  const pickerOptions = useMemo((): IPickerOption[] => {
    return [
      { value: LOCALES.EN, label: localeStore.t('english') },
      { value: LOCALES.AR, label: localeStore.t('arabic') },
    ];
  }, []);

  return (
    <div className="kiosk__field">
      <Text type="order-field" text="language" required className="kiosk__field-title" />

      <div className="flex-1">
        <TabPicker
          options={pickerOptions}
          value={kioskEditStore.editableKiosk.language}
          className="flex-1 width-fit"
          onChange={handleLanguageChange}
        />
      </div>
    </div>
  );
});

export default KioskLanguage;
